import React from 'react'
import { arrayOf, string } from 'prop-types'
import styled from 'styled-components'
import { Flex } from 'rebass'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton
} from 'react-share'
import { media } from '../../utils/style'
import typography from '../../utils/typography'

import LogoTwitter from '../../vectors/LogoSocialTwitter'
import LogoFacebook from '../../vectors/LogoSocialFacebook'
import LogoLinkedIn from '../../vectors/LogoSocialLinkedin'

import { space, layout, color } from 'styled-system'

const Share = styled(Flex)`
  align-items: center;
  justify-content: center;
  ${media.MediumScreenUp`
    align-items: left;
    justify-content: left;
  `};

  h5 {
    position: relative;
    top: -2px;
    margin-bottom: 0;
    margin-right: 20px;
    text-transform: uppercase;
    text-align: center;
    ${media.MediumScreenUp`
      margin-bottom: ${typography.rhythm(1)};
      text-align: left;
      transform: translateX(-18%);
    `};
  }
  svg {
    width: 26px;
    height: 26px;
  }
  svg > path {
    transition: fill 0.5s ${(props) => props.theme.ease.ease_out_expo};
    fill: ${(props) => props.theme.colors.grey_light_op30};
  }
  .SocialMediaShareButton--facebook {
    svg:hover > path {
      fill: #415a9f;
    }
  }
  .SocialMediaShareButton--linkedin {
    svg:hover > path {
      fill: #3d78b8;
    }
  }
  .SocialMediaShareButton--twitter {
    svg:hover > path {
      fill: #00aced;
    }
  }

  .SocialMediaShareButton {
    cursor: pointer;
    display: inline-block;
    width: 26px;
    margin: 12px 15px 2px;
    ${media.MediumScreenUp`
      display: block;
      width: 100%;
      margin: 0 0 10px 0;
    `};
  }
`

const LineDivider = styled.hr`
  background: none;
  color: #d7dae1;
  ${media.MediumScreenUp`
    color: white;
  `};

  ${space}
  ${layout}
  ${color}
`

class ContentArticleSocialShare extends React.PureComponent {
  render() {
    const topLine =
      this.props.position === 'top' ? <LineDivider width={1} /> : null
    const bottomLine =
      this.props.position === 'bottom' ? <LineDivider width={1} /> : null
    return (
      <Share flexWrap="wrap" mb={[0, 40]} mt={['-8px', 0]} py={[10, 0]}>
        {bottomLine}
        <h5>Share</h5>
        <TwitterShareButton
          title={this.props.title}
          url={this.props.url}
          via={'CitygateCars'}
        >
          <LogoTwitter />
        </TwitterShareButton>
        <FacebookShareButton
          quote={this.props.title}
          url={this.props.url}
          hashtag={this.props.hashtag ? `#${this.props.hashtag[0]}` : null}
        >
          <LogoFacebook />
        </FacebookShareButton>
        <LinkedinShareButton title={this.props.title} url={this.props.url}>
          <LogoLinkedIn />
        </LinkedinShareButton>
        {topLine}
      </Share>
    )
  }
}

ContentArticleSocialShare.defaultProps = {
  title: '',
  url: '',
  position: '',
  hashtag: []
}
ContentArticleSocialShare.propTypes = {
  title: string,
  url: string,
  position: string,
  hashtag: arrayOf(string)
}

export default ContentArticleSocialShare
